import { render, staticRenderFns } from "./temperature.vue?vue&type=template&id=0cb768bf&scoped=true&"
import script from "./temperature.vue?vue&type=script&lang=js&"
export * from "./temperature.vue?vue&type=script&lang=js&"
import style0 from "./temperature.vue?vue&type=style&index=0&id=0cb768bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb768bf",
  null
  
)

export default component.exports